<div class="tab-section">
    <div *ngIf='installedData.length > 0'>
    <div class="dropdown-select ml-15">
        <p class="textBlueBold mr-10">Division : </p>
        <p-dropdown 
            [options]="dropDownData" 
            [(ngModel)]="selectedDivision" 
            optionLabel="label"
            optionValue="value"
            [autoDisplayFirst]="true"
            (onChange)="onDivisionChange()">
        </p-dropdown>
    </div>
    
    <p-table [value]="filterdInstalledData" [scrollable]="true" id="StyleTable" scrollHeight="400px">
        <ng-template pTemplate="header">
            <tr>
                <th >Division</th>
                <th >Section</th>
                <th pSortableColumn="tag_number">TLR#</th>
                <th pSortableColumn="status">TLR Status</th>
                <th></th>
                <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
            <tr>
                <td>{{row.division_name}}</td>
                <td>{{row.section_name}}</td>
                <td [ngClass]="row.cssClass">{{row.tag_number}}</td>
                <td [ngClass]="row.cssClass">{{row.status}}</td>
                <td><a (click)="details(row)" class="link-underline">Details</a></td>
                <td><a (click)="assignToMe(row)" class="link-underline">Assign to Me</a></td>
            </tr>
        </ng-template>
    </p-table>
</div>
<div *ngIf="installedData.length == 0">
    <p class="messageTitle">There are no TLR's that have been OA (Installed)</p>
</div>
</div>